var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "45", height: "44", viewBox: "0 0 45 44", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-19a)" },
      React.createElement("path", { d: "M0.5 22C0.5 34.1503 10.3497 44 22.5 44C34.6503 44 44.5 34.1503 44.5 22C44.5 9.84974 34.6503 0 22.5 0C10.3497 0 0.5 9.84974 0.5 22Z", fill: "#000" }),
      React.createElement("path", { d: "M22.7227 14.3846C23.5547 14.3846 24.5977 13.8048 25.2188 13.0318C25.7812 12.3312 26.1914 11.3528 26.1914 10.3744C26.1914 10.2416 26.1797 10.1087 26.1562 10C25.2305 10.0362 24.1172 10.6402 23.4492 11.4495C22.9219 12.0655 22.4414 13.0318 22.4414 14.0223C22.4414 14.1672 22.4648 14.3121 22.4766 14.3605C22.5352 14.3725 22.6289 14.3846 22.7227 14.3846ZM19.793 29C20.9297 29 21.4336 28.2149 22.8516 28.2149C24.293 28.2149 24.6094 28.9758 25.875 28.9758C27.1172 28.9758 27.9492 27.7921 28.7344 26.6325C29.6133 25.3039 29.9766 23.9994 30 23.939C29.918 23.9148 27.5391 22.9123 27.5391 20.0979C27.5391 17.658 29.4141 16.5588 29.5195 16.4743C28.2773 14.6383 26.3906 14.59 25.875 14.59C24.4805 14.59 23.3438 15.4596 22.6289 15.4596C21.8555 15.4596 20.8359 14.6383 19.6289 14.6383C17.332 14.6383 15 16.595 15 20.2912C15 22.5861 15.8672 25.014 16.9336 26.5842C17.8477 27.9129 18.6445 29 19.793 29Z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-19a" },
        React.createElement("path", { fill: "#fff", transform: "translate(.5)", d: "M0 0H44V44H0z" })
      )
    )
  );
});